module.exports = __webpack_public_path__ + "img/company1.f69934d8.png";